import { CardBackgroundViewModel } from '../../card-background-view-model';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { CardStack } from '../../../../../../../models/menu/section/card-stacks/card-stack';
import { Observable } from 'rxjs';
import type { GenericCardData } from '../../../../../../../models/print-cards/generic-card-data';

@Injectable()
export class GenericAddressCardStackBackgroundViewModel extends CardBackgroundViewModel {
  public readonly cardData$: Observable<GenericCardData>;

  public readonly colorStripWidth$ = this.cardStack$.pipe(
    map(cardStack => {
      const bleed = (cardStack?.nonPerforatedBleedBorderInInches() ?? 0) * CardStack.PIXELS_PER_INCH;
      const additionalHeight = cardStack?.isOnRegularPaper() ? bleed : 0;
      return `calc(6.25rem + ${additionalHeight}px)`;
    })
  );
}
